import { render, staticRenderFns } from "./ModalAddProfile.vue?vue&type=template&id=67a7b7a4&scoped=true"
import script from "./ModalAddProfile.vue?vue&type=script&lang=js"
export * from "./ModalAddProfile.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProfile.vue?vue&type=style&index=0&id=67a7b7a4&prod&lang=scss&scoped=true"
import style1 from "./ModalAddProfile.vue?vue&type=style&index=1&id=67a7b7a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7b7a4",
  null
  
)

export default component.exports